module.exports = __webpack_public_path__ + "418d3c262a710bf0bb13dd854e9adaa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/Lobeofthelung.jpg
// module id = 880
// module chunks = 0